var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1ArrLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02692 0.00103179C6.25388 0.000771457 6.47384 0.0471682 6.6486 0.132169C6.74696 0.180034 6.82826 0.238819 6.88786 0.305156C6.94745 0.371493 6.98417 0.444078 6.9959 0.518756C7.00763 0.593435 6.99414 0.668738 6.95622 0.740352C6.91829 0.811967 6.85667 0.878487 6.77488 0.9361L6.67417 1.00682C4.58876 2.47133 4.56089 5.55196 6.61946 7.05396C6.70014 7.11228 6.7604 7.17939 6.79676 7.25142C6.83312 7.32346 6.84487 7.399 6.83133 7.47371C6.81779 7.54841 6.77923 7.62082 6.71786 7.68675C6.6565 7.75268 6.57354 7.81084 6.47375 7.85789C6.37325 7.9098 6.25555 7.94895 6.12805 7.97289C6.00054 7.99683 5.86598 8.00504 5.73281 7.99701C5.59965 7.98898 5.47074 7.96488 5.3542 7.92622C5.23765 7.88757 5.13597 7.83519 5.05555 7.77237L0.363831 4.35138C0.22096 4.24936 0.142856 4.12139 0.142856 3.98933C0.142856 3.85726 0.22096 3.7293 0.363831 3.62727L5.22068 0.206291C5.31813 0.137291 5.44191 0.0827468 5.58199 0.0470842C5.72208 0.0114211 5.87451 -0.00435648 6.02692 0.00103179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ArrLeft);
export default __webpack_public_path__ + "static/media/1arr-left.a73a36e4d20f903a88bae6919fe49667.svg";
export { ForwardRef as ReactComponent };